/* eslint-disable no-nested-ternary */
import React from "react";

import { Checkbox, Tooltip } from "antd";

import { SPEC_FLAGS_MAP } from "../../../../../Common/constants/SpecFlagConstants";
import StyledScrollbar from "../../../../../Common/UIComponents/StyledScrollbar";
import LockedValue from "../../../../../grace-period/components/LockedValue";
import { useAccessStatus } from "../../../../../grace-period/hooks/useAccessStatus";
import { PINS_SPEC_STYLE_MAP } from "../../Constant";

export default function ResultTable({
  date,
  data,
  isGeneratingPartial,
  testCheckboxVals,
  setTestCheckboxVals,
  reportPathExists,
}) {
  const { areResultsLocked } = useAccessStatus();

  /**
   * Handle clicking on the checking
   * @param {number} index index of the test
   */
  const handleCheckClicked = (index) => {
    const checked = testCheckboxVals[date] && testCheckboxVals[date]?.length > 0 ? testCheckboxVals[date][index]?.checked : false;
    setTestCheckboxVals((state) => {
      const updated = { ...state };
      const obj = updated[date] && updated[date]?.length > 0 ? updated[date][index] : {};
      if (!updated[date]) updated[date] = [];
      updated[date][index] = { ...obj, checked: !checked };
      return updated;
    });
  };

  /** display the spec data only if there are spec values */
  const renderTableRow = (rowData, index, notemptyspec) => {
    const {
      test, test_spec, test_result, test_spec_flag, message, test_category,
    } = rowData;
    const { color, box_shadow_color } = SPEC_FLAGS_MAP[test_spec_flag] ?? SPEC_FLAGS_MAP.invalid;
    const outOfSpec = !areResultsLocked && (test_spec_flag === "2" || test_spec_flag === "6");
    const hasMessage = message?.trim() !== "";
    const disabledTest = areResultsLocked || test_spec_flag === "0" || !test_result || hasMessage || test_category === "MRL" || reportPathExists[date]; // true if checkbox is disabled
    const checked = testCheckboxVals[date] && testCheckboxVals[date]?.length > 0 ? testCheckboxVals[date][index]?.checked : false; // true if checkbox is checked
    const inProcessTextColor = PINS_SPEC_STYLE_MAP[0].color;
    return (
      <tr
        style={{ backgroundColor: outOfSpec && !hasMessage ? box_shadow_color : "#EFF2F3" }}
        key={index}
        onClick={disabledTest ? undefined : () => handleCheckClicked(index)} // Clicking on row will check/uncheck the box
      >
        <td>
          <div className={`ResultTable__TestColumnContainer${isGeneratingPartial && disabledTest ? " ResultTable__TestColumnContainer--disabled" : ""}`}>
            {isGeneratingPartial && (
              <span onClick={(e) => e.stopPropagation()}>
                <Checkbox
                  disabled={disabledTest}
                  checked={checked ?? false}
                  onChange={() => handleCheckClicked(index)}
                />
              </span>
            )}
            {test}
          </div>
        </td>
        {notemptyspec
          && (
            <td>
              <div className="test-spec">{test_spec}</div>
            </td>
          )}
        <td style={{ color: areResultsLocked ? undefined : (hasMessage ? inProcessTextColor : color) }}>
          <div className="ResultBox">
            {areResultsLocked ? (
              <LockedValue locked />
            ) : (
              <>
                {test_result}
                {hasMessage && (
                  <Tooltip
                    title={message}
                    placement="top"
                    overlayClassName="SampleTestResultTable__TestingInProgressTooltip"
                  >
                    <span className="UnderQCReviewText">
                      {message}
                    </span>
                  </Tooltip>
                )}
              </>
            )}
          </div>
        </td>
      </tr>
    );
  };

  if (data !== undefined) {
    const notemptyspec = (data.map((item) => (item.test_spec === "-" ? "true" : "false"))).includes("false");
    return (
      <StyledScrollbar className="env-report-view-results-table-scrollbar">
        <table className="env-report-view-report-section-results-table">
          <thead className="env-report-view-report-section-results-table-header">
            <tr>
              <th>Test</th>
              {notemptyspec && (<th>Specs</th>)}
              <th>Results</th>
            </tr>
          </thead>
          <tbody className="env-report-view-report-section-results-table-body">
            {data.map((item, idx) => (
              renderTableRow(item, idx, notemptyspec)
            ))}
          </tbody>
        </table>
      </StyledScrollbar>
    );
  } return (
    <table className="env-report-view-report-section-results-table" />
  );
}
